import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import RitImageBlock from '../RitImageBlock/RitImageBlock';

const Container = styled.div`
`;

const ImageWrapper = styled.div`
  position: relative;
`;

const ImageTitle = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
    background: white;
    padding: 5px;
    border-radius: 2px;
`;

export const EmbroideryPreviewContent = ({ items }) => {

    return (
        <Container>
                    <ImageWrapper>
                        <RitImageBlock src={`/images/details/embroideryPlace.jpg`} />
                    </ImageWrapper>
        </Container>
    );
}

EmbroideryPreviewContent.propTypes = {
    items: PropTypes.array.isRequired,
}
